"use client"

import * as RadTooltip from "@radix-ui/react-tooltip"
import BrowserNameProvider from "app/_components/BrowserNameProvider"
import ThemeProvider, { ThemeProviderProps } from "components/theme/ThemeProvider"
import React from "react"
import { SWRConfig } from "swr"
import LocalesProvider, { LocalesProviderProps } from "./LocalesProvider"

export type RootProvidersProps = {
  themeProviderProps: ThemeProviderProps
  localesProviderProps: LocalesProviderProps
}

const RootProviders: React.FC<React.PropsWithChildren<RootProvidersProps>> = ({
  children,
  themeProviderProps,
  localesProviderProps,
}) => {
  return (
    <RadTooltip.Provider>
      <SWRConfig value={{ shouldRetryOnError: false }}>
        <ThemeProvider {...themeProviderProps}>
          <LocalesProvider {...localesProviderProps}>
            <BrowserNameProvider>{children}</BrowserNameProvider>
          </LocalesProvider>
        </ThemeProvider>
      </SWRConfig>
    </RadTooltip.Provider>
  )
}

export default RootProviders
